import { Toaster } from "@loot-os/ui/components/sonner";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { queryClient } from "./lib/queryClient";
import { initSentry } from "./lib/sentry";
import { TRPCProvider, trpcClient } from "./lib/trpc";
import { router } from "./router";
import "@loot-os/ui/globals.css";
// The embeddable opener ships one self-contained stylesheet; the box preview
// mounts it, so the dashboard needs it exactly like the storefront does.
import "@loot-os/react/styles.css";

initSentry(router);

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("missing #root element");

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <RouterProvider router={router} />
        {/* Every toast in the app lands here — mutation errors from the query
            client, saves, and the standing notices. Outside the router on
            purpose: a toast's action navigates through a closure, not a Link. */}
        <Toaster />
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
